import {axiosInstance} from "@/plugins/axios";

export interface ProductDeterminationPayload {
    start_application_date: string,
    end_application_date: string,
    determination_status: string,
    search_option: string,
    search_content: string,
    originating_status: string,
    trade_section: string,
    agreement_group: string,
    customer_name?: string
}

export interface ProductDeterminationsPayload {
    start_application_date: string,
    end_application_date: string,
    product_determinations: number[],
    errors?: boolean,
    determined?: boolean,
}

export interface ProductMaterialDeterminationsPayload {
    start_application_date: string,
    end_application_date: string,
    id_item: string,
    product_specific_rule?: string,
    agreement?: string
}

export interface ProductMaterialDeterminationsByIdsPayload {
    start_application_date: string,
    end_application_date: string,
    id_items: number[],
}

export interface ProductDeterminationBillOfMaterials {
    start_application_date: string,
    end_application_date: string,
    id_item: number,
    subassembly: boolean
}

export async function getProductMaterialDeterminationsByItemIds(payload: ProductMaterialDeterminationsByIdsPayload) {
    let url = 'product_determinations/items?';
    if (payload && payload.start_application_date !== "" && payload.end_application_date !== "") {
        url += `start_application_date=${payload.start_application_date}&end_application_date=${payload.end_application_date}&`;
    }
    if (payload && payload.id_items.length > 0) {
        payload.id_items.forEach(item => {
            url += `id_items=${item}&`;
        })
    }
    const response = await axiosInstance.get(url);
    return response.data;
}

export async function getProductMaterialDeterminations(payload: ProductMaterialDeterminationsPayload) {
    let url = 'product_determinations/item?';

    if (payload && payload.start_application_date !== "" && payload.end_application_date !== "") {
        url += `start_application_date=${payload.start_application_date}&end_application_date=${payload.end_application_date}&`;
    }

    if (payload && payload.id_item !== '') {
        url += `id_item=${payload.id_item}&`;
    }

    if (payload && payload.product_specific_rule) {
        url += `product_specific_rule=${payload.product_specific_rule}&`;
    }

    if (payload && payload.agreement) {
        url += `agreement=${payload.agreement}&`;
    }

    const response = await axiosInstance.get(url);
    return response.data;
}

export async function getProductDetermination(payload: ProductDeterminationPayload) {
    let url = 'product_determinations/products?';

    if (payload && payload.determination_status) {
        url += `determination_status=${payload.determination_status}&`;
    }

    if (payload && payload.start_application_date !== "" && payload.end_application_date !== "") {
        url += `start_application_date=${payload.start_application_date}&end_application_date=${payload.end_application_date}&`
    }

    if (payload && payload.search_option) {
        if(payload.search_option === 'CODE' && payload.search_content) {
            url += `item_code=${payload.search_content}&`
        } else if (payload.search_option === 'NAME' && payload.search_content) {
            url += `client_name=${payload.search_content}&`
        }
    }

    if (payload && payload.originating_status) {
        if (payload.originating_status === 'ORIGINATING') {
            url += `originating_status=${true}&`
        } else if (payload.originating_status === 'NON_ORIGINATING') {
            url += `originating_status=${false}&`
        }
    }

    if (payload && payload.trade_section && payload.trade_section !== '') {
        if (payload.trade_section === 'DOMESTIC') {
            url += `trade_section=MX&`
        } else {
            url += `trade_section=${payload.trade_section}&`
        }
    }

    if (payload && payload.agreement_group && payload.agreement_group !== '' && payload.agreement_group !== 'ALL') {
        url += `agreement_group=${payload.agreement_group}&`
    }

    if (payload && payload.customer_name) {
        url += `customer_name=${payload.customer_name}`;
    }

    const response = await axiosInstance.get(url);

    return response.data;
}

export async function getSubassemblyDetermination(payload: ProductDeterminationPayload) {
    let url = 'product_determinations/subassemblies?';

    if (payload && payload.determination_status) {
        url += `determination_status=${payload.determination_status}&`;
    }

    if (payload && payload.start_application_date !== "" && payload.end_application_date !== "") {
        url += `start_application_date=${payload.start_application_date}&end_application_date=${payload.end_application_date}&`
    }

    if (payload && payload.search_option) {
        if(payload.search_option === 'CODE' && payload.search_content) {
            url += `item_code=${payload.search_content}&`
        } else if (payload.search_option === 'NAME' && payload.search_content) {
            url += `client_name=${payload.search_content}&`
        }
    }

    if (payload && payload.originating_status) {
        if (payload.originating_status === 'ORIGINATING') {
            url += `originating_status=${true}&`
        } else if (payload.originating_status === 'NON_ORIGINATING') {
            url += `originating_status=${false}&`
        }
    }

    if (payload && payload.trade_section !== '') {
        if (payload.trade_section === 'DOMESTIC') {
            url += `trade_section=MX&`
        } else {
            url += `trade_section=${payload.trade_section}&`
        }
    }

    if (payload && payload.agreement_group && payload.agreement_group !== '' && payload.agreement_group !== 'ALL') {
        url += `agreement_group=${payload.agreement_group}&`
    }

    const response = await axiosInstance.get(url);

    return response.data;
}

export async function getItemBillOfMaterials(payload: ProductDeterminationBillOfMaterials) {
    let url = `product_determinations/virtual/${payload.id_item}?subassembly=${payload.subassembly}&`;

    if (payload && payload.start_application_date !== "" && payload.end_application_date !== "") {
        url += `start_application_date=${payload.start_application_date}&end_application_date=${payload.end_application_date}&`
    }
    const response = await axiosInstance.get(url);
    return response.data;
}

export async function saveProductDeterminations(payload: ProductDeterminationsPayload) {
    const response = await axiosInstance
        .post('product_determinations/create_or_update_many', payload);

    return response.data;
}


export async function createProductDeterminationReport(payload: ProductDeterminationsPayload) {
    const response = await axiosInstance
        .post('product_determinations/report', payload);

    return response.data;
}
